/* eslint-disable no-case-declarations */
import BasicLayout from '@components/layout/BasicLayout'
import Divider from '@components/pageComponents/Divider'
import FullScreenContainer from '@components/pageComponents/FullScreenContainer'
import ImageText from '@components/pageComponents/ImageText'
import PageSeo from '@components/seo/PageSeo'
import getPage from '@operations/queries/getPage'
import getSiteSettings from '@operations/queries/getSiteSettings'
import React from 'react'
import ReactMarkdown from 'react-markdown'

import Custom404 from './404'

const CatchAllPages = ({ data: { page, siteSettings } }) => {
  if (!page) return Custom404

  const pageContent = page?.content.map(content => {
    switch (content.__component) {
      case 'page-components.text':
        const contentComponent = <ReactMarkdown>{content.content}</ReactMarkdown>
        return (
          <FullScreenContainer
            key={`${content.__component}_${content.id}`}
            container={content.container}
            fullScreenSection={content.fullScreenSection}
          >
            {contentComponent}
          </FullScreenContainer>
        )
      case 'page-components.image-text':
        return <ImageText key={`${content.__component}_${content.id}`} content={content} />
      case 'page-components.divider':
        const sectionDividerImage = content.image?.formats?.medium?.url
          ? content.image?.formats?.medium?.url
          : content.image?.url
        return (
          <Divider
            key={`${content.__component}_${content.id}`}
            marginTop={content.marginTop}
            src={sectionDividerImage}
          />
        )
      default:
        break
    }
  })
  return (
    <BasicLayout
      footerLinks={siteSettings?.footerLinks}
      footerLogo={siteSettings?.footerLogo?.url}
      headerLinks={siteSettings?.headerLinks}
      headerLogo={siteSettings?.logo?.url}
      socialLinks={siteSettings?.socialLinks}
    >
      <PageSeo
        description={page.seo?.description}
        image={page.seo?.image?.formats?.medium?.url}
        title={page.seo?.title || `${page.title} | Skyclimbers`}
      />
      {pageContent}
    </BasicLayout>
  )
}

export const getStaticPaths = async () => {
  const pagesList = await getPage()
  const paths =
    pagesList?.filter(page => {
      if (
        page.slug === 'world' ||
        page.slug === 'privacy-policy' ||
        page.slug === 'sentipedia' ||
        page.slug === 'shop'
      ) {
        return null
      }
      return page
    }) || []
  const filteredPaths = paths?.map(page => ({ params: { slug: [page.slug] } })) || []
  return {
    fallback: false,
    paths: filteredPaths,
  }
}

export const getStaticProps = async ({ params }) => {
  const { slug } = params
  let page
  let siteSettings
  if (process.env.API_URL) {
    page = await getPage(slug)
    siteSettings = await getSiteSettings()
  }

  return {
    props: {
      data: {
        page: page?.[0] || null,
        siteSettings: siteSettings || null,
      },
    },
    revalidate: false,
  }
}

export default CatchAllPages
